import { render, staticRenderFns } from "./OtherExpenses.vue?vue&type=template&id=3f7dd636&"
import script from "./OtherExpenses.vue?vue&type=script&lang=js&"
export * from "./OtherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./OtherExpenses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports